import { render, staticRenderFns } from "./makeSurePas_phone.vue?vue&type=template&id=ff8a7f86&scoped=true"
import script from "./makeSurePas_phone.vue?vue&type=script&lang=js"
export * from "./makeSurePas_phone.vue?vue&type=script&lang=js"
import style0 from "./makeSurePas_phone.vue?vue&type=style&index=0&id=ff8a7f86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8a7f86",
  null
  
)

export default component.exports